var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.531,
    x2: 252.081,
    xlinkHref: "#lg1",
    y1: 384.06,
    y2: 416.29
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.807,
    x2: 370.357,
    xlinkHref: "#lg1",
    y1: 384.06,
    y2: 416.29
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.174,
    x2: 296.044,
    xlinkHref: "#lg1",
    y1: 415.336,
    y2: 438.867
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.631,
    x2: 339.474,
    xlinkHref: "#lg1",
    y1: 95.072,
    y2: 463.411
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc2b5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89580"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.186,
    x2: 378.673,
    xlinkHref: "#lg2",
    y1: 359.12,
    y2: 303.314
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.026,
    x2: 321.695,
    xlinkHref: "#lg1",
    y1: 103.342,
    y2: 256.399
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.128,
    x2: 266.727,
    xlinkHref: "#lg2",
    y1: 254.248,
    y2: 246.245
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.873,
    x2: 334.208,
    xlinkHref: "#lg1",
    y1: 202.371,
    y2: 261.876
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.999,
    x2: 254.999,
    xlinkHref: "#lg2",
    y1: 319.474,
    y2: 431.557
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 195.861,
    cy: 398.621,
    fill: "url(#SVGID_1_)",
    r: 50.245
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.137,
    cy: 398.621,
    fill: "url(#SVGID_2_)",
    r: 50.245
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 254.999,
    cy: 425.967,
    fill: "url(#SVGID_3_)",
    r: 36.683
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168.017 400.061c50.199 42.505 123.764 42.505 173.963 0l135.261-114.53c57.846-48.98 36.145-128.72-42.022-154.409-117.066-38.473-243.373-38.473-360.439 0-78.168 25.688-99.869 105.428-42.023 154.409z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.247 285.525-135.262 114.532c-4.282 3.628-8.737 6.95-13.339 9.938-20.903 13.7-44.727 20.983-68.751 21.85v-329.55c59.2.494 118.361 10.111 175.32 28.826 13.86 4.562 25.959 10.818 36.136 18.315 47.234 34.696 53.477 95.804 5.896 136.089z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.679 405.066c26.327 34.543 78.311 34.543 104.638 0l149.828-196.582c27.61-36.226 13.829-83.304-31.078-106.173-107.479-54.733-234.658-54.733-342.137 0-44.908 22.869-58.688 69.947-31.078 106.173z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.067 102.311c-52.246-26.606-109.147-40.275-166.177-41.014v369.473c17.905-1.32 35.362-9.873 47.428-25.704l149.828-196.582c27.61-36.226 13.829-83.304-31.079-106.173z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.605 420.933c3.075 13.094 21.712 13.094 24.786 0l69.262-294.964c4.721-20.107-2.597-40.814-19.807-56.043-34.017-30.101-89.68-30.101-123.697 0-17.211 15.23-24.529 35.936-19.807 56.043z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m34.509 287.015 133.508 113.046c50.199 42.505 123.764 42.505 173.963 0l133.508-113.046z",
    fill: "url(#SVGID_9_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShell);
export default __webpack_public_path__ + "static/media/icon-shell.50b7bc13d3b740182e760799d75b9dcf.svg";
export { ForwardRef as ReactComponent };